<template>
  <div class="list">
    <notifications></notifications>
    <navbar :title="$t('global.batixsoftware')"></navbar>
    <div class="container-fluid">
      <div class="row">
        <div class="col-2">
          <div class="container-fluid">
            <head-menu-filter
              :col="12"
              class="d-xl-flex"
              :headline="$t('global.filter')"
            ></head-menu-filter>

            <div class="row mb-2">
              <div
                class="
                  viewfilter
                  block
                  br-t-l-0 br-t-r-0
                  w-100-p
                  br-t-l-xl-0 br-t-r-xl-0
                  mt-minus-10
                "
              >
                <div class="row">
                  <div class="col-xl-12">
                    <div class="form-group">
                      <input
                        v-model="filters.firma"
                        class="form-control input"
                        type="text"
                        placeholder=" "
                      />
                      <label>{{ $t("global.company") }}</label>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-xl-12">
                    <div class="form-group">
                      <input
                        v-model="filters.ansprechpartner"
                        class="form-control input"
                        type="text"
                        placeholder=" "
                      />
                      <label>{{ $t("global.Contactperson") }}</label>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-xl-12">
                    <single-select-person
                      id="verantwortlicher"
                      :person="filters.verantwortlicher"
                      :label="$t('global.creator')"
                      :allowOpen="false"
                      editable
                      :rollen="filterMitarbeitende"
                      @confirmed="setVerantwortlicher"
                    />
                  </div>
                </div>
                <div class="row">
                  <div class="col-xl-12">
                    <div class="form-group">
                      <v-select
                        v-model="filters.typ"
                        label="bezeichnung"
                        :options="leadtypen"
                        :placeholder="$t('dashboard.type')"
                      >
                        <span slot="no-options">{{ $t("notification.taptosearch") }}</span>
                      </v-select>
                      <label>{{ $t("dashboard.type") }}</label>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-xl-12">
                    <div class="form-group">
                      <v-select
                        v-model="filters.artikel"
                        :options="artikelListe"
                        label="bezeichnung"
                        :placeholder="$t('global.item')"
                      >
                        <template slot="option" slot-scope="option">
                          {{ option.kurzbezeichnung }} -
                          {{ option.bezeichnung }} ({{ option.artikelnummer }})
                        </template>

                        <template slot="selected-option" slot-scope="option">
                          {{ option.kurzbezeichnung }} -
                          {{ option.bezeichnung }} ({{ option.artikelnummer }})
                        </template>
                        <span slot="no-options">{{ $t("notification.taptosearch") }}</span>
                      </v-select>
                      <label>{{ $t("global.item") }}</label>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-xl-12">
                    <div class="form-group">
                      <v-select
                        v-model="filters.status"
                        label="bezeichnung"
                        :options="status"
                        :placeholder="$t('global.stage')"
                        :reduce="(sId) => sId.id"
                      >
                        <span slot="no-options">{{ $t("notification.taptosearch") }}</span>
                      </v-select>
                      <label>{{ $t("global.stage") }}</label>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-xl-12">
                    <div class="form-group">
                      <input
                        v-model="filters.count"
                        class="form-control input"
                        type="text"
                        placeholder=" "
                      />
                      <label>{{ $t("global.numberofrecords") }}</label>
                    </div>
                  </div>
                </div>
                <filter-search-reset-button/>
              </div>
            </div>
          </div>
        </div>
        <div class="col-10">
          <div class="container-fluid">
            <head-menu
              :col="12"
              class="d-xl-flex"
              :headline="$t('dashboard.leads')"
              :anzahl="leadliste.length"
              :anzahlAusFilter="anzahlDatenFilter"
            ></head-menu>
            <div class="row mb-2">
              <div class="block br-t-l-0 w-100-p br-t-l-xl-0">
                <div class="row mt-2 d-flex justify-content-between">
                  <div class="ml-4 mr-2">
                    <button
                      class="btn btn-success mr-2"
                      @click="neuerLead"
                      v-if="berechtigungen.m_lead.create"
                    >
                      <font-awesome-icon icon="fa-regular fa-plus" />
                      {{ $t("global.new") }}
                    </button>
                  </div>
                  <div class="mr-4">
                    <button
                      class="btn btn-danger"
                      @click="oeffneLoeschenModal"
                      v-if="berechtigungen.m_lead.delete"
                      :disabled="isDisabled"
                    >
                      <font-awesome-icon
                        icon="fa-duotone fa-trash"
                        class="mr-2"
                      />
                      <span>{{ $t("global.delete") }}</span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div class="row block belegliste">
              <div class="w-100-p">
                <div>
                  <b-table
                    ref="selectableTable"
                    small
                    tbody-tr-class="item"
                    :items="listData"
                    :fields="fields"
                    :sort-compare="sortDates"
                    sort-icon-left
                    fixed
                    selectable
                    select-mode="range"
                    @row-dblclicked="details"
                  >
                    <template slot="top-row" slot-scope="{ fields }">
                      <td v-for="field in fields" :key="field.key">
                        <b-input
                          v-if="
                            field.key != 'selected' && field.searchable != false
                          "
                          size="sm"
                          v-model="filters[field.key]"
                          :placeholder="field.label"
                        />
                      </td>
                    </template>

                    <template v-slot:head(selected)="header">
                      <b-form-checkbox
                        ref="headerCheckbox"
                        v-model="header.selected"
                        @input="selectAllRows(header)"
                      ></b-form-checkbox>
                    </template>

                    <template v-slot:cell(selected)="row">
                      <b-form-checkbox
                        v-model="row.item.selected"
                        @input="onRowSelected(row)"
                      ></b-form-checkbox>
                    </template>
                  </b-table>

                  <infinite-loading
                    :identifier="infiniteId"
                    @infinite="infiniteHandler"
                  >
                    <div slot="spinner">{{ $t("global.loadmoredata") }}</div>
                    <div slot="no-more">{{ $t("global.nofurtherdata") }}</div>
                    <div slot="no-results">{{ $t("global.nofurtherdatafound") }}</div>
                  </infinite-loading>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <loeschen-modal
      id="leads-loeschen-modal"
      @confirmed="loeschen"
      :multiple="true"
    />

    <loading-overlay v-show="loading"></loading-overlay>
  </div>
</template>

<script>
import Api from "@/Api";
import HeadMenu from "@/components/HeadMenu";
import HeadMenuFilter from "@/components/HeadMenuFilter";
import Navbar from "@/components/Navbar";
import LoeschenModal from "@/components/Modals/LoeschenModal";
import store from "@/store";
import page from "@/mixins/Page";
import numeral from "numeral";
import dashboard from "@/mixins/Dashboard";
import filter from "@/mixins/Filter";

import SingleSelectPerson from "@/components/global/SingleSelectPerson.vue";
import FilterSearchResetButton from "@/components/Buttons/FilterSearchResetButton";

import { LADE_AUSWAHLWERTE_CRM } from "@/store/crm/actions.type";
import { LADE_ARTIKEL } from "@/store/artikel/actions.type";

export default {
  name: "Leads",
  components: {
    Navbar,
    HeadMenu,
    HeadMenuFilter,
    LoeschenModal,
    SingleSelectPerson,
    FilterSearchResetButton,
  },
  metaInfo() {
    return {
      titleTemplate: () => {
        return "BX: " + this.$t("dashboard.leads");
      },
    };
  },
  mixins: [page, dashboard, filter],
  props: {
    id: {
      type: String,
      required: false,
      default: null,
    },
  },
  store,
  data() {
    return {
      leadliste: [],
      isDisabled: false,
      selected: [],
      selectedIds: [],
      filterMitarbeitende: this.$CONST("ROLLEN").MITARBEITER,

      fields: [
        { key: "selected", label: "" },
        {
          key: "typ.appkey",
          label: this.$t("dashboard.type"),
          sortable: true,
          formatter: (value) => {
            if (value) {
              return value == "leada" ? "A" : value == "leadb" ? "B" : "C";
            } else {
              return "";
            }
          },
          tdClass: "text-center",
          thClass: "text-center",
          searchable: false,
        },
        {
          key: "firma",
          sortable: true,
          label: this.$t("global.company"),
          searchable: true,
          formatter: (value) => {
            if (value) return value.name;
            else return "";
          },
        },
        {
          key: "ansprechpartner",
          sortable: true,
          label: this.$t("global.Contactperson"),
          searchable: true,
          formatter: (value) => {
            if (value) return value.personName;
            else return "";
          },
        },
        {
          key: "bezeichnung",
          sortable: true,
          label: this.$t("global.designation"),
          searchable: false,
        },
        {
          key: "umsatz",
          sortable: true,
          label: this.$t("global.sales"),
          formatter: (value) => {
            if (value) {
              return numeral(value).format("#,##0.00");
            } else {
              return "";
            }
          },
          tdClass: "text-right",
          thClass: "text-center",
          searchable: false,
        },
        {
          key: "umsatzbewertet",
          sortable: true,
          label: this.$t("global.evaluated"),
          formatter: (value) => {
            if (value) {
              return numeral(value).format("#,##0.00");
            } else {
              return "";
            }
          },
          tdClass: "text-right",
          thClass: "text-center",
          searchable: false,
        },
        {
          key: "stage.bezeichnung",
          sortable: true,
          label: this.$t("global.stage"),
          searchable: false,
        },
        {
          key: "erfassungsdatum",
          sortable: true,
          label: this.$t("global.recorded"),
          tdClass: "text-center",
          thClass: "text-center",
          searchable: false,
        },
        {
          key: "abschlussdatum",
          sortable: true,
          label: this.$t("global.completiondate"),
          tdClass: "text-center",
          thClass: "text-center",
          searchable: false,
        },
        {
          key: "verantwortlicher",
          sortable: true,
          label: this.$t("global.Responsible"),
          searchable: false,
          formatter: (value, key, item) => {
            if (value && value.personeninformation)
              return value.personeninformation.personName;
            else return "";
          },
        },
      ],
    };
  },
  computed: {
    queryParams: function () {
      var params = {}

      params.typ = this.setQueryParam(this.filters.typ?.id);
      params.art = this.setQueryParam(this.filters.artikel?.id);
      params.f = this.setQueryParam(this.filters.firma);
      params.ap = this.setQueryParam(this.filters.ansprechpartner);
      params.ver = this.setQueryParam(this.filters.verantwortlicher?.id);
      params.filterCount = this.setQueryParam(this.filters.count);
      params.status = this.setQueryParam(this.filters.status);

      return params;
    },
    artikelListe() {
      let tempList = this.$store.state.artikel.artikel;
      return tempList.sort((a, b) =>
        a.kurzbezeichnung.localeCompare(b.kurzbezeichnung)
      );
    },
    leadtypen: {
      get() {
        return this.$store.state.crm.leadtypen;
      },
    },
    status: {
      get() {
        return this.$store.state.crm.leadstages;
      },
    },
  },
  created() {
    this.initFilter("lead-liste", "crm/lead/", true);
  },
  mounted() {
    this.$bus.$emit("searchWithFilter");
    if (this.leadtypen.length == 0)
      this.$store.dispatch(`crm/${LADE_AUSWAHLWERTE_CRM}`);

    if (this.artikelListe.length == 0)
      this.$store.dispatch(`artikel/${LADE_ARTIKEL}`);
    this.setHeaders("global", [
      "",
      "",
      "company",
      "Contactperson",
      "designation",
      "sales",
      "evaluated",
      "stage",
      "recorded",
      "completiondate",
      "Responsible",
    ]);
    this.setHeaders("dashboard", [
      "",
      "type",
    ]);
  },
  methods: {
    details(lead) {
      this.$router.push({
        name: "lead",
        params: { id: lead.id, anzeige: 0 },
      });
    },

    neuerLead() {
      this.$router.push({
        name: "lead",
        params: { anzeige: 0 },
      });
    },

    loeschen() {
      Api.delete("crm/lead/", { data: this.selectedIds }).then((response) => {
        this.schliesseLoeschenModal();

        this.listData = this.listData.filter(
          (v) => !response.data.success.includes(v.id)
        );
      });
    },

    schliesseLoeschenModal() {
      $("#leads-loeschen-modal").modal("hide");
    },

    oeffneLoeschenModal() {
      $("#leads-loeschen-modal").modal("show");
    },

    setVerantwortlicher(person) {
      this.$set(this.filters, "verantwortlicher", person);
    },
  },
};
</script>

<style>
</style>
